import SideNavLayout from "../customsidenav/sidenavlayout"
import UsersTable from "./userstable"
import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import api from "../api/api";
import AddnewUser from "./AddnewUser";
import ReactPaginate from "react-paginate";
import FilterByRoleModal from "./filtermodal";
import { getPracticeId, practiceShortName, staffFaceEnrol } from "../config/practice";
import { PlusGlyph, SearchGlyph } from "./userui";
import { filterIcon } from "../landingscreen/modals/svgs";
import {
  DEPT_FILTER_ALL,
  DEPT_FILTER_NONE,
  departmentFilterName,
  departmentOptions,
  departmentsById,
  fetchUsersWithDepartments,
  matchesDepartmentFilter,
  userDepartment,
} from "./userDepartments";
import PrivilegeMatrix from "./privileges/PrivilegeMatrix";
import "./user.css";
const UserTab=()=>{
    const [addnewUser, setaddnewUser] = useState(false);
    const [sortOrder,setSortOrder]=useState('desc')
    const [showRoleFilter, setShowRoleFilter] = useState(false);
const [appliedRoles, setAppliedRoles] = useState([]);
const [lastActiveSort, setLastActiveSort] = useState("desc");
// The status strip and the Face ID picker, both display filters over the
// same rows the page already fetched.
const [statusTab, setStatusTab] = useState("All");
const [faceTab, setFaceTab] = useState("any");

// /v1/{{practiceid}}/users
const [currentPage, setCurrentPage] = useState(0);
      const [users, setUsers] = useState([]);  // State to store the user data
  const [loading, setLoading] = useState(false);  // Loading state to show the loading indicator
  const [searchQuery, setSearchQuery] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [imagesdata,setImageData]=useState([])
    const practiseid = getPracticeId();
    const [sortColumn, setSortColumn] = useState("status");
    // Department column + filter (owner 11-03). From the new v2 users/departments route, which answers
    // user administrators only: anyone else (or no answer) keeps the screen exactly as before.
    const [deptById, setDeptById] = useState({});
    const [deptOptions, setDeptOptions] = useState([]);
    const [deptEnabled, setDeptEnabled] = useState(false);
    const [deptFilter, setDeptFilter] = useState("");
    // Users | Privileges (owner 11-03): the matrix view, for user administrators (the same signal as the
    // department column: the admin-only v2 users/departments answered).
    const [view, setView] = useState("users");
    const loadDepartments = async () => {
      try {
        const res = await fetchUsersWithDepartments();
        if (res?.status === 200 && Array.isArray(res.data)) {
          setDeptById(departmentsById(res.data));
          setDeptOptions(departmentOptions(res.departments));
          setDeptEnabled(true);
          return;
        }
      } catch (e) {
        /* not a user administrator, or v2 did not answer */
      }
      setDeptEnabled(false);
    };

  // Fetch user data
   const getStatus = (item) => {
    const status = item.status?.trim().toUpperCase();
    const locked = item.locked_status?.trim().toUpperCase();

    if (status === "I") return "Inactive";
    if (locked === "I") return "Locked";
    return "Active";
  };

  const fetchUsersData = async () => {
    setLoading(true);  // Start loading

    // Ensure the practice ID is correct

    console.log("Practice ID:", practiseid); // Log to check the practice ID

    try {
      const response = await api.get(`/v1/${practiseid}/users`);  // Fetch users for the specific practice ID
      if (response.status === 200) {
        setUsers(response.data);  // Set the user data
        loadDepartments();
      } else {
        setUsers([]);  // Clear users if response isn't successful
      }
    } catch (error) {
      console.error('Error fetching users:', error.response || error.message || error);
      setUsers([]);  // Clear users in case of error
    } finally {
      setLoading(false);  // Stop loading
    }
  };
  const fetchimgs=async()=>{
    try {
      const response = await api.get(`/v1/${practiseid}/users/profile-pictures`)

      if(response.status==200){

        setImageData(response?.data||[])
      }else{
        setImageData([])
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Use effect or event to trigger the fetch function (example)
  useEffect(() => {
    document.title = `${practiceShortName()} - User Management`;
    fetchUsersData();
    fetchimgs()

  }, []);  // Dependency

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

const uploadimg = async ({file,id}) => {
  try {
    console.log(id)
    const formData = new FormData();
    formData.append("file", file);
    const upload = await api.post(
      `/v1/${practiseid}/user/${id}/upload-profile-picture`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (upload.status === 200) {
      fetchimgs()
      fetchUsersData(true); // Refresh profile
    }
  } catch (error) {
    console.log(error);
  }
};
  const AddnewModalClose=()=>{
   setaddnewUser(false)
  }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };
  // FILTER USERS - the search box names what it matches, so it reads the same
  // four fields the column headings do.
const filteredUsers = users
  .filter((u) => {
    const q = searchQuery.toLowerCase();
    const hay = [u.firstname, u.lastname, `${u.firstname} ${u.lastname}`, u.username, u.email, u.rolename]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    const roleMatch =
      appliedRoles.length === 0 ||
      appliedRoles.includes(u.rolename?.trim());

    const deptMatch =
      !deptEnabled || matchesDepartmentFilter(userDepartment(deptById, u), deptFilter);

    return hay.includes(q) && roleMatch && deptMatch;
  });

  // The strip and the Face ID picker narrow it further; the strip's own counts
  // come off filteredUsers, so they do not move as you switch between them.
  const visibleUsers = filteredUsers.filter((u) => {
    if (statusTab !== "All" && getStatus(u) !== statusTab) return false;
    if (faceTab === "enrolled" && !u?.config?.enrolled_id) return false;
    if (faceTab === "not" && u?.config?.enrolled_id) return false;
    return true;
  });

  // SORTING PRIORITY
  const priority = { Active: 3, Locked: 2, Inactive: 1 };

  // SORT USERS BEFORE PAGINATION
const shownUsers = [...visibleUsers].sort((a, b) => {
  const statusA = priority[getStatus(a)];
  const statusB = priority[getStatus(b)];

  const dateA = new Date(a.last_login || 0).getTime();
  const dateB = new Date(b.last_login || 0).getTime();

  // 🟦 CASE 1: Sorting by STATUS first, then Last Active
  if (sortColumn === "status") {
    // Primary: Status
    const primary = sortOrder === "asc"
      ? statusA - statusB
      : statusB - statusA;

    if (primary !== 0) return primary;

    // Secondary: Last Active
    return lastActiveSort === "asc" ? dateA - dateB : dateB - dateA;
  }

  // 🟩 CASE 2: Sorting by LAST ACTIVE first, then Status
  if (sortColumn === "last_active") {
    // Primary: Last Active
    const primary = lastActiveSort === "asc"
      ? dateA - dateB
      : dateB - dateA;

    if (primary !== 0) return primary;

    // Secondary: Status
    return sortOrder === "asc"
      ? statusA - statusB
      : statusB - statusA;
  }

  return 0;
});

  // PAGINATION. One clamped index drives the slice, the "Showing x-y" range
  // and the pager, so a filter that shrinks the list can never leave them
  // disagreeing - react-paginate swallows a click on the page it already
  // thinks is selected, which would otherwise strand the table empty.
  const pageCount = Math.ceil(shownUsers.length / itemsPerPage);
  const page = Math.max(0, Math.min(currentPage, pageCount - 1));
  const currentUsers = shownUsers.slice(
    page * itemsPerPage,
    (page + 1) * itemsPerPage
  );
const endIndex = Math.min(
    (page + 1) * itemsPerPage,
    shownUsers.length
  );
  const startIndex = page * itemsPerPage + 1;
  useEffect(() => {
    setCurrentPage(0);
  }, [itemsPerPage]);
  // The role filter modal and its chips set appliedRoles without touching the
  // page, so the reset lives here rather than at each call site.
  useEffect(() => {
    setCurrentPage(0);
  }, [appliedRoles]);
  const changestatus=async(user)=>{
  try {
    setLoading(true)
       const payload ={
            "rowid": user.id,
            "practiceid":practiseid,
             "email":user.email,
            "status": user.status === "A" ? "I" : "A",

        }
         const response = await api.put(`/v1/${practiseid}/user`, payload);
  } catch (error) {
    console.log(error)
  }finally{
    setLoading(false)
    fetchUsersData()
  }
}
  // The status strip: the three states the rows have always carried, counted
  // off the search/role-filtered set so the numbers match what is listed.
  const STATUS_TABS = ["All", "Active", "Inactive", "Locked"];
  const statusCount = (key) =>
    key === "All"
      ? filteredUsers.length
      : filteredUsers.filter((u) => getStatus(u) === key).length;


  return (
    <>
     <div className="h-full">
    <SideNavLayout>
      <div className="bmus">
        {deptEnabled && (
          <div className="bmus-tabs bmus-views" role="tablist" aria-label="User admin views">
            {[["users", "Users"], ["privileges", "Privileges"]].map(([key, label]) => (
              <button key={key} type="button" role="tab" aria-selected={view === key}
                      className={`bmus-tab${view === key ? " on" : ""}`} onClick={() => setView(key)}>
                {label}
              </button>
            ))}
          </div>
        )}
        {deptEnabled && view === "privileges" ? (
          <PrivilegeMatrix deptOptions={deptOptions} />
        ) : (<>
        {/* Search and filter on top, then the status and Face ID picks,
            as on the dashboard and the other screens. */}
        <div className="bmus-bar">
          <div className="bmus-bar-top">
            <label className="bmus-search">
              {SearchGlyph}
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="Search name, user ID, email or role"
                aria-label="Search users"
              />
            </label>

            <div className="bmus-bar-end">
              <button
                type="button"
                className="bmus-icon-btn"
                onClick={() => setShowRoleFilter(true)}
                title="Filter by role"
                aria-label="Filter by role"
              >
                {filterIcon}
              </button>

              <button type="button" className="bmus-add" onClick={() => setaddnewUser(true)}>
                {PlusGlyph} Add new user
              </button>
            </div>
          </div>

          <div className="bmus-bar-sub">
            <div className="bmus-tabs" role="group" aria-label="Filter by status">
              {STATUS_TABS.map((key) => (
                <button
                  key={key}
                  type="button"
                  className={`bmus-tab${statusTab === key ? " on" : ""}`}
                  aria-pressed={statusTab === key}
                  onClick={() => {
                    setStatusTab(key);
                    setCurrentPage(0);
                  }}
                >
                  {key} <span className="bmus-tab-n">{statusCount(key)}</span>
                </button>
              ))}
            </div>

            {staffFaceEnrol() && (
              <div className="bmus-pick">
                <span className="bmus-pick-k">Face ID</span>
                <select
                  className="bmus-select"
                  aria-label="Filter by Face ID"
                  value={faceTab}
                  onChange={(e) => {
                    setFaceTab(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="any">Any</option>
                  <option value="enrolled">Enrolled</option>
                  <option value="not">Not enrolled</option>
                </select>
              </div>
            )}

            {deptEnabled && (
              <div className="bmus-pick">
                <span className="bmus-pick-k">Department</span>
                <select
                  className="bmus-select"
                  aria-label="Filter by department"
                  value={deptFilter}
                  onChange={(e) => {
                    setDeptFilter(e.target.value);
                    setCurrentPage(0);
                  }}
                >
                  <option value="">All departments</option>
                  {deptOptions.map((d) => (
                    <option key={d.id} value={d.id}>{d.name}</option>
                  ))}
                  <option value={DEPT_FILTER_ALL}>All-departments users</option>
                  <option value={DEPT_FILTER_NONE}>Department not set</option>
                </select>
              </div>
            )}

            {(appliedRoles.length > 0 || (deptEnabled && deptFilter)) && (
              <div className="bmus-chips">
                {deptEnabled && deptFilter && (
                  <span className="bmus-chip">
                    {departmentFilterName(deptFilter, deptOptions)}
                    <button type="button" aria-label="Remove department filter" onClick={() => setDeptFilter("")}>
                      ×
                    </button>
                  </span>
                )}
                {appliedRoles.map((role, index) => (
                  <span key={index} className="bmus-chip">
                    {role}
                    <button
                      type="button"
                      aria-label={`Remove ${role}`}
                      onClick={() => setAppliedRoles((prev) => prev.filter((r) => r !== role))}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>

        <UsersTable
          changestatus={changestatus}
          setSortOrder={setSortOrder}
          sortOrder={sortOrder}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          lastActiveSort={lastActiveSort}
          setLastActiveSort={setLastActiveSort}
          onFileChange={uploadimg}
          users={currentUsers}
          fetchUsersData={fetchUsersData}
          imagesdata={imagesdata}
          deptEnabled={deptEnabled}
          deptById={deptById}
          deptOptions={deptOptions}
        />

        <div className="bmus-foot">
          <span>
            Showing <b>{shownUsers.length === 0 ? 0 : startIndex}–{endIndex}</b> of{" "}
            <b>{shownUsers.length}</b> users
          </span>
          <div className="bmus-foot-r">
            <div className="bmus-pick">
              <span className="bmus-pick-k">Per page</span>
              <select
                className="bmus-select"
                aria-label="Rows per page"
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                value={itemsPerPage}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <ReactPaginate
              previousLabel={<span aria-hidden="true">‹</span>}
              nextLabel={<span aria-hidden="true">›</span>}
              breakLabel="…"
              breakClassName="break-me"
              pageCount={pageCount}
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={1}
              forcePage={page}
              renderOnZeroPageCount={null}
              containerClassName="pagination"
              activeClassName="active-page"
              disabledClassName="disabled"
            />
          </div>
        </div>
        </>)}
      </div>
    </SideNavLayout>
{showRoleFilter && (
  <FilterByRoleModal
    users={users}
    appliedRoles={appliedRoles}
    onApply={(roles) => setAppliedRoles(roles)}
    onClose={() => setShowRoleFilter(false)}
  />
)}

        <Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={loading}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
               {addnewUser&&<AddnewUser uploadimg={uploadimg} fetchUsersData={fetchUsersData} AddnewModalClose={AddnewModalClose}/>}
     </div>


    </>)
}
export default UserTab
